import React from "react"
import {Container} from "@mui/material";


interface Props {
    background?: string,
    children?: JSX.Element | JSX.Element[],
    className?: string,
    customStyle?: any,
    id?: string,
    noTopMargin?: boolean,
    noBottomMargin?: boolean,
    smallmargin?: boolean
    dataCypress?: string
    fullWidthOnMobile?: boolean
}

function CCOComponentWrapper(props: Props) {
    let mt: any = 0;
    if (!props.noTopMargin) {
        if (props.smallmargin) {
            mt = 3;
        } else {
            mt = {xl: 12, lg: 12, md: 12, sm: 6, xs: 6}
        }
    }
    let mb: any = 0;
    if (!props.noBottomMargin) {
        if (props.smallmargin) {
            mb = 6;
        } else {
            mb = {xl: 24, lg: 24, md: 24, sm: 12, xs: 12}
        }
    }

    return <Container data-cypress={props.dataCypress} className={props.className} sx={{
        mt: mt,
        mb: mb,
        mx: props.fullWidthOnMobile ? {xs: 0, sm: 0} : 0,
        py: props.background ? 6 : 0,
        px: props.fullWidthOnMobile ? {xs: 0, sm: 0} : { md: 0, sm: '24px', xs: '16px' },
        width: "100%",
        backgroundColor: props.background === 'grey'
            ? 'var(--background-grey)'
            : props.background ? props.background : '',
        ...props.customStyle
    }}
                      maxWidth={false}
                      id={props.id}
    >

        {props.children}

    </Container>
}


export default CCOComponentWrapper